export default __webpack_public_path__ + "static/media/unfinished1.7749dabb.png";